import Decimal from 'decimal.js-light';

export function getTokenRate({
  buyAmount,
  sellAmount,
}: {
  buyAmount: Decimal | number;
  sellAmount: Decimal | number;
}) {
  // if the amounts are not numbers, return nothing otherwise Decimal will throw errors
  if (Number.isNaN(buyAmount) || Number.isNaN(sellAmount)) {
    return;
  }

  const buyAmountDecimal = new Decimal(buyAmount);
  const sellAmountDecimal = new Decimal(sellAmount);

  if (buyAmountDecimal.isZero() || sellAmountDecimal.isZero()) {
    return;
  }

  return {
    sell: buyAmountDecimal.div(sellAmountDecimal),
    buy: sellAmountDecimal.div(buyAmountDecimal),
  };
}
